import { getOrganizerAudioSettingsAction } from 'Reducks/Webinar/actions';
import { getOrganizerWebinarSettingsAction,
  updateOrganizerWebinarSettingsAction,
  getG2MSettingsAction,
  updateOrganizerAudioSettingsAction } from './actions';

const defaultState = {
  organizerSettings: {
    error: false,
    isFetching: false,
    isCertificatesEnabled: false,
    isCertificatesEntitled: false,
    isCertificatesProvisioned: false,
    isSourceTrackingEnabled: false,
    isSourceTrackingEntitled: false,
    isSourceTrackingProvisioned: false,
    isVideoLibraryEnabled: true,
    isRestrictAccountUserSearchEnabled: false,
    audio: {},
    gotoAppEnabled: false
  }
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case getG2MSettingsAction.complete.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: false,
          gotoAppEnabled: action.data.gotoAppEnabled
        }
      };
    }
    case getG2MSettingsAction.failed.toString():
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: false
        }
      };
    case getG2MSettingsAction.toString():
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: true
        }
      };
    case getOrganizerWebinarSettingsAction.fulfilled.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          ...action.payload,
          isFetching: false,
          error: null
        }
      };
    }
    case updateOrganizerWebinarSettingsAction.complete.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          ...action.data,
          isFetching: false
        }
      };
    }
    case getOrganizerWebinarSettingsAction.pending.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: true,
          error: false
        }
      };
    }
    case getOrganizerWebinarSettingsAction.rejected.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: false,
          error: true
        }
      };
    }
    case updateOrganizerAudioSettingsAction.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: true
        }
      };
    }
    case updateOrganizerAudioSettingsAction.complete.toString(): {
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          audio: action.audioDetails,
          isFetching: false
        }
      };
    }
    case getOrganizerAudioSettingsAction.toString():
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          audio: {},
          isFetching: true
        }
      };
    case getOrganizerAudioSettingsAction.complete.toString():
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          audio: action.data,
          isFetching: false
        }
      };
    case updateOrganizerAudioSettingsAction.failed.toString():
    case getOrganizerAudioSettingsAction.failed.toString():
      return {
        ...state,
        organizerSettings: {
          ...state.organizerSettings,
          isFetching: false
        }
      };

    default:
      return state;
  }
};
